import Vue from 'vue'
import Router from 'vue-router'

import InsurancePolicy from '../pages/InsurancePolicy/index.vue'
import PolicyDetail from '../pages/PolicyDetail/index.vue'
import SendEmail from '../pages/SendEmail/index.vue'
import SendSuccess from '../pages/SendSuccess/index.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/p/v',
      name: 'InsurancePolicy',
      component: InsurancePolicy
    }, {
      path: '/policydetail',
      name: 'PolicyDetail',
      component: PolicyDetail
    }, {
      path: '/SendEmail',
      name: 'SendEmail',
      component: SendEmail
    }, {
      path: '/SendSuccess',
      name: 'SendSuccess',
      component: SendSuccess
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js